<script>
import { mapActions } from 'vuex'
import { list, get, del } from '@/api/tabelapreco'

// Colunas
import columns from './colunas'

export default {
  props: {
    mode: { type: String, default: 'tab' }
  },
  async mounted () {
    this.modalAdd = await this.newModal({
      component: 'app-tabelapreco-edit',
      width: 300,
      onSave: async (data) => {
        if (data.tabela) this.refresh(data.tabela)
        else this.$refs.completeGrid.refreshList()
      },
      onCancel: () => {
        this.$refs.completeGrid.focoPesquisa()
      }
    })
  },
  data () {
    return {
      tela: 'tabela_preco',
      acoes: {
        add: 'tabela_preco_incluir',
        edit: 'tabela_preco_editar',
        delete: 'tabela_preco_excluir'
      },
      modalAdd: false,
      columns: columns,
      indices: [
        { value: 'tabela', label: 'Descrição' },
        { value: 'fator_multiplicacao', label: 'Fator Multiplicação' },
        { value: 'ativa', label: 'Ativa' }
      ]
    }
  },
  methods: {
    ...mapActions({
      newModal: 'modal/new',
      openModal: 'modal/open',
      confirmarModal: 'modal/confirmar',
      toaster: 'modal/toaster'
    }),
    refresh (data) {
      if (this.mode === 'tab') this.$refs.completeGrid.refreshList()
      else if (this.mode === 'modal') this.$refs.completeGrid.changeBusca(data)
    },
    async getList (filtros) {
      let data = await list(filtros)
      return {
        data: data.data,
        totalCount: data.total
      }
    },
    async novo () {
      let data = { tabela: null, fator_multiplicacao: null, ativa: 'S' }
      this.openModal({ modal: this.modalAdd, data })
    },
    async editar (row) {
      let data = await get(row.data.id)
      this.openModal({ modal: this.modalAdd, data })
    },
    async excluir (row) {
      this.confirmarModal({
        msg: 'Deseja realmente excluir esse tabela?',
        onConfirm: async () => {
          await del(row.data.id)
          this.toaster({ message: 'Excluido com sucesso!', color: 'success' })
          this.$refs.completeGrid.refreshList()
        }
      })
    },
    async selecionar (selecionado) {
      if (selecionado.id) this.$emit('save', selecionado)
    }
  }
}
</script>

<template>
  <ui-layout-modal :mode="mode" title="Listar Tabela Preco" @onClose="() => $emit('cancel')">
    <ui-complete-grid
      ref="completeGrid"
      :tela="tela"
      :columns="columns"
      :indices="indices"
      :selection="mode === 'modal'"
      :datasource="getList"
      :acoes="acoes"
      @onSelect="selecionar"
      @onCancel="$emit('cancel')"
      @onAdd="novo"
      @onEdit="editar"
      @onDelete="excluir" />
  </ui-layout-modal>
</template>
